import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import {
  DsAutosuggestModule,
  DsButtonModule,
  DsTooltipDirectiveModule,
  SelectListOption,
  SuggestionItem,
} from '@bmw-ds/components';

import { SuggestionItemWithAddress } from '../../../clients/tolerant-post/model/view.model';
import { InputFieldComponent } from '../../../form/components/input-field/input-field.component';
import { SelectFieldComponent } from '../../../form/components/select-field/select-field.component';
import { useI18n } from '../../../i18n/services/i18n.service';

@Component({
  selector: 'cdf-single-line-address-search',
  imports: [SelectFieldComponent, InputFieldComponent, DsButtonModule, DsTooltipDirectiveModule, DsAutosuggestModule],
  template: `
    <cdf-select-field
      [(model)]="country"
      id="country"
      [placeholder]="i18n('placeholder.country')"
      [options]="availableCountries()"
      [disabled]="disabled()"
      isClearable
    />
    <cdf-input-field
      [(model)]="singleLineSearch"
      id="one-line-search"
      [placeholder]="i18n('customerInformationDialog.placeholder.enterAddress')"
      [suggestions]="suggestions()"
      [disabled]="!country() || disabled()"
      [ds-tooltip]="i18n('customerInformationDialog.info.enterCountryFirst')"
      [dsTooltipConfig]="{ origin: 'bottom', disabled: !!country() || disabled() }"
      (suggestionSelected)="selectSuggestion.emit($event)"
    />
    <div class="fill-address-fields">
      <ds-button
        [ds-tooltip]="overwriteButtonTooltipText()"
        [dsTooltipConfig]="{
          origin: 'bottom',
          disabled: isSingleLineSuggestionSelected() || disabled() || !overwriteButtonTooltipText(),
        }"
        variant="outline"
        (click)="applyAddressSuggestion.emit()"
        [disabled]="!isSingleLineSuggestionSelected() || disabled()"
      >
        {{ overwriteButtonText() }}
      </ds-button>
    </div>
  `,
  styleUrl: './single-line-address-search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleLineAddressSearchComponent {
  readonly i18n = useI18n();

  readonly country = model<string>();
  readonly singleLineSearch = model<string>();

  readonly overwriteButtonTooltipText = input<string>('');
  readonly overwriteButtonText = input<string>('');
  readonly suggestions = input<SuggestionItemWithAddress[]>();
  readonly isSingleLineSuggestionSelected = input(false);
  readonly availableCountries = input<SelectListOption[]>([]);

  readonly disabled = input<boolean>(false);

  readonly applyAddressSuggestion = output();
  readonly selectSuggestion = output<SuggestionItem>();
}
